import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./ModalCadastroParcela.scss"; // Crie um arquivo de estilo se necessário
import Swal from "sweetalert2";
import { Label } from "../Label/styles";
import InputComponent from "../../components/Input/input";
import Button from "../../components/Button/button";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import {
  CreateFinancialRecordDto,
  CreateManyInLoteFichaFinanceiraDto,
  ResponseCreateManyInLoteFichaFinanceiraDto,
} from "../../shared/dtos/FichaFinanceira.dto";
import { StatusImpressaoEnum } from "../../shared/enum/fichaFinanceira.enum";
import {
  BlueTitle,
  ContainerInput,
  MainContainer,
  ModalBody,
  ModalBodyContainer,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextError,
} from "../../shared/styles/global.styles";
import { IoCloseSharp } from "react-icons/io5";
import { Col, Row } from "react-bootstrap";
import { LocalPagamentoDto } from "../../shared/dtos/LocalPagamento.dto";
import { Lotacao } from "../../shared/interfaces/DadosFinanceirosInterface";
import lotacaoService from "../../services/LotacaoService";
import localPagamentoService from "../../services/LocalPagamentoService";
import SelectComponent from "../Select/select";
import contribuinteService from "../../services/ContribuinteService";
import { ContainerCount, LabelCount } from "./styles";
import ModalDetalhes from "./ModalDetalhes/modalDetalhes";
import { progressBarSwalAlert } from "../ProgressBarSwalAlert/ProgressBarSwalAlert";
import { Colors } from "../../shared/colors/colors";
import requestInProgressService from "../../services/RequestInProgressService";

// Define os tipos das props para o componente
interface CadastroParcelaProps {
  onClose: () => void;
  dadosFinanceiros?: {
    imprimir: boolean;
    dataExclusao?: string | null;
  };
  show: boolean;
}

// Função para formatar valores monetários
// const formatCurrency = (value: string) => {
//   value = value.replace(/\D/g, ""); // Remove caracteres não numéricos
//   value = (parseFloat(value) / 100).toFixed(2).replace(".", ","); // Formata como valor monetário
//   return value.replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Adiciona separadores de milhar
// };

const CadastroParcelasVariosContribuintes: React.FC<CadastroParcelaProps> = ({
  onClose,
  dadosFinanceiros,
  show,
}) => {
  const hoje = new Date();
  const [parcela, setParcela] = useState<CreateFinancialRecordDto>({
    statusParcela: "Ativa",
    sequencialParcela: "1",
    nossoNumero: "0",
    tipoCobranca: "Mensalidade",
    valorParcela: "",
    dataVencimentoInicio: hoje.toISOString().split("T")[0],
    dataVencimentoFim: hoje.toISOString().split("T")[0],
    valorAjuste: "0",
    valorPago: "0",
    valorTarifa: "0",
    dataPagamento: "",
    statusImpressao: dadosFinanceiros?.imprimir
      ? StatusImpressaoEnum.A_IMPRIMIR
      : StatusImpressaoEnum.NAO_IMPRIMIR,
    statusRemessa: "Enviar",
    statusRemessaBaixa: "Enviar",
    tipoExclusao: null,
    dataGeracao: hoje.toISOString().split("T")[0],
    usuarioGeracao: "",
    codigoBarras: "",
    qrCodePix: "",
    numeroRemessa: 0,
    numeroRetorno: 0,
    dataCaixa: hoje.toISOString().split("T")[0],
  });
  const [locaisPagamento, setLocaisPagamento] = useState<LocalPagamentoDto[]>(
    []
  );
  const [lotacoes, setLotacoes] = useState<Lotacao[]>([]);
  const [isRequest, setIsRequest] = useState(false);
  const [selectLocalPagamento, setSelectLocalPagamento] =
    useState<LocalPagamentoDto>();
  const [selectLotacao, setSelectLotacao] = useState<Lotacao>();
  const [modalDetalhesAberto, setModalDetalhesAberto] =
    useState<boolean>(false);

  const [totalContribuintes, setTotalContribuintes] = useState<number>();
  const [
    responseCreateFinancialRecordAllContribuintesDto,
    setResponseCreateFinancialRecordAllContribuintesDto,
  ] = useState<CreateManyInLoteFichaFinanceiraDto>();

  const fetchLocaisPagamento = async () => {
    try {
      const response =
        await localPagamentoService.getAllLocaisPagamentoWithLayoutRemessaRetorno();
      setLocaisPagamento(response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao buscar locais de pagamento",
        allowOutsideClick: false,
      });
    }
  };

  const fetchLotacoes = async () => {
    try {
      const response = await lotacaoService.getAllLotacoes();
      setLotacoes(response);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar lotações. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  };

  const handleDateChange = (date: string, field: string) => {
    setParcela({ ...parcela, [field]: date });
  };

  const handleSubmit = async () => {
    const dateInicio = new Date(parcela.dataVencimentoInicio);
    const dateFim = new Date(parcela.dataVencimentoFim);
    if (dateInicio.getTime() > dateFim.getTime()) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Data de início não pode ser maior que a data de fim",
        allowOutsideClick: false,
      });
      return;
    }
    if (!parcela.dataVencimentoInicio || !parcela.dataVencimentoFim) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Data de vencimento não pode estar vazia",
        allowOutsideClick: false,
      });
      return;
    }
    setIsRequest(true);

    const result = await Swal.fire({
      icon: "question",
      title: "Confirmação",
      text: "Você realmente deseja cadastrar as parcelas?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        Swal.fire({
          icon: "info",
          title: "Aguarde",
          text: "Efetuando cadastro de parcelas, por favor aguarde",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const data = {
          parcelas: [
            {
              dataVencimentoInicio: parcela.dataVencimentoInicio,
              dataVencimentoFim: parcela.dataVencimentoFim,
            },
          ] as [{}],
          params: {
            dateInitial: parcela.dataVencimentoInicio,
            dateFinal: parcela.dataVencimentoFim,
            idLotacao: selectLotacao?.id,
            idLocalPagamento: selectLocalPagamento?.id,
          },
        };
        await FichaFinanceiraService.cadastrarParcelasTodosContribuintesEmLote(
          data
        ).then(async (responseCreateParcelas) => {
          if (responseCreateParcelas.success) {
            Swal.fire({
              title: "Processando solicitação",
              html: progressBarSwalAlert({
                currentProgress: 0,
                totalProgress: 0,
                color: Colors.primary,
                showProgressText: true,
              }),
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            let stopLoopCreateParcelas = false;
            let getRequestInProgressCreateParcelas =
              await requestInProgressService.getRequestInProgressById(
                responseCreateParcelas.data.id
              );
            await new Promise((resolve) => setTimeout(resolve, 2000));

            while (!stopLoopCreateParcelas) {
              getRequestInProgressCreateParcelas =
                await requestInProgressService.getRequestInProgressById(
                  responseCreateParcelas.data.id
                );

              if (getRequestInProgressCreateParcelas.finished) {
                stopLoopCreateParcelas = true;
              } else {
                Swal.update({
                  html: progressBarSwalAlert({
                    currentProgress:
                      getRequestInProgressCreateParcelas.currentProgress,
                    totalProgress:
                      getRequestInProgressCreateParcelas.totalProgress,
                    color: Colors.primary,
                    showProgressText: true,
                    progressText: "Criando parcelas aguarde...",
                  }),
                });
                await new Promise((resolve) => setTimeout(resolve, 2000));
              }
            }
            await requestInProgressService.deleteRequestInProgress(
              responseCreateParcelas.data.id
            );
            if (!getRequestInProgressCreateParcelas.error) {
              // Se o status da resposta for 'sucesso', exibe uma mensagem de sucesso
              if (getRequestInProgressCreateParcelas.responseData) {
                const response: CreateManyInLoteFichaFinanceiraDto = JSON.parse(
                  getRequestInProgressCreateParcelas.responseData
                );
                setResponseCreateFinancialRecordAllContribuintesDto(response);
                setTotalContribuintes(0);
                // Fecha a tela de loading
                Swal.close();
                // Caso o status da resposta seja diferente de sucesso, exibe uma mensagem informando sobre o processo.
                Swal.fire({
                  icon: "success",
                  title: "Processo Finalizado com sucesso!",
                  text: `Os contribuintes com dados financeiros inválidos ou parcelas já cadastradas no período foram ignorados.`,
                  showCancelButton: true,
                  confirmButtonText: "Ver detalhes",
                  cancelButtonText: "Fechar",
                  allowOutsideClick: false,
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    setIsRequest(false);
                    setModalDetalhesAberto(true);
                  } else {
                    if (response.nameFileDetails) {
                      await FichaFinanceiraService.deleteFileInPdfs(
                        response.nameFileDetails
                      );
                    }
                    setIsRequest(false);
                    setModalDetalhesAberto(false);
                    onClose();
                  }
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Erro ao cadastrar parcelas",
                  text: "Ocorreu um erro ao cadastrar as parcelas, por favor tente novamente",
                  allowOutsideClick: false,
                });
              }
            } else {
              const response: CreateManyInLoteFichaFinanceiraDto = JSON.parse(
                getRequestInProgressCreateParcelas.responseData
              );
              const resultDeleteFile =
                await FichaFinanceiraService.deleteFileInPdfs(
                  response.nameFileDetails || ""
                );
              if (resultDeleteFile.success) {
                Swal.fire({
                  title: "Erro",
                  text: getRequestInProgressCreateParcelas.message,
                  icon: "error",
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                });
              }
            }
          } else {
            Swal.fire({
              title: "Erro",
              text: "Ocorreu um erro ao solicitar o cadastro das parcelas. Por favor, tente novamente.",
              icon: "error",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        });
      } catch (error) {
        // Caso ocorra um erro, exibe a mensagem de erro
        Swal.fire({
          icon: "error",
          title: "Erro ao solicitar cadastro de parcelas",
          text: "Ocorreu um erro ao solicitar o cadastro das parcelas, por favor tente novamente",
          allowOutsideClick: false,
        });
        console.error("Erro ao solicitar cadastro de parcelas:", error);
      }
    } else {
      setIsRequest(false);
    }
  };

  const countContribuintes = async () => {
    setIsRequest(true);
    const data = {
      idLocalPagamento: selectLocalPagamento
        ? selectLocalPagamento.id
        : undefined,
      idLotacao: selectLotacao ? selectLotacao.id : undefined,
    };
    await contribuinteService
      .countContribuintesByLotacaoOrLocalPagamento(data)
      .then((result) => {
        setTotalContribuintes(result);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Erro ao verificar total de fichas financeiras",
          text: error.message || "Ocorreu um erro ao processar sua solicitação",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
        setTotalContribuintes(0);
      });

    setIsRequest(false);
  };

  const handleCloseModal = () => {
    setModalDetalhesAberto(false);
    onClose();
  };

  useEffect(() => {
    fetchLocaisPagamento();
    fetchLotacoes();
  }, []);

  useEffect(() => {
    countContribuintes();
  }, [selectLocalPagamento, selectLotacao]);

  return (
    <MainContainer>
      <ModalContainer show={show}>
      <ModalContent width={40}>
          <Button
            type="button"
            schemaButton="x-close"
            action={() => onClose()}
            icon={<IoCloseSharp size={30} />}
            position="absolute"
            top={10}
            right={10}
          />
          <ModalHeader>
            <BlueTitle>
              Cadastrar Parcelas para todos os contribuintes
            </BlueTitle>
          </ModalHeader>

          <ModalBody>
            <ContainerInput>
              <Label htmlFor="localPagamento">Local de Pagamento</Label>
              <SelectComponent
                color="black"
                placeholder="Todos locais de pagamento"
                isPlaceHolder={false}
                id="localPagamento"
                width={Number("100%")}
                name="localPagamento"
                disabled={isRequest}
                value={selectLocalPagamento?.id?.toString() ?? ""}
                onChange={(e) => {
                  const selectedLocal = locaisPagamento.find(
                    (local) => local.id === parseInt(e.target.value)
                  );
                  setSelectLocalPagamento(selectedLocal);
                }}
                options={locaisPagamento.map((local) => ({
                  value: local.id!.toString(),
                  label: local.descricao,
                }))}
              />
            </ContainerInput>
            <ContainerInput>
              <Label htmlFor="lotacao">Lotação</Label>
              <SelectComponent
                color="black"
                placeholder="Todas"
                isPlaceHolder={false}
                id="lotacao"
                width={Number("100%")}
                name="lotacao"
                disabled={isRequest}
                value={selectLotacao?.id?.toString() ?? ""}
                onChange={(e) => {
                  if (e.target.value === "0") {
                    setSelectLotacao({ id: 0, descricao: "Sem Lotacao" });
                  } else {
                    const selectedLotacao = lotacoes.find(
                      (lotacao) => lotacao.id === parseInt(e.target.value)
                    );
                    setSelectLotacao(selectedLotacao);
                  }
                }}
                options={[
                  { value: "0", label: "Sem lotação" },
                  ...lotacoes.map((lotacao) => ({
                    value: lotacao.id!.toString(),
                    label: lotacao.descricao,
                  })),
                ]}
              />
            </ContainerInput>
            {totalContribuintes !== undefined ? (
              <ContainerCount>
                <Label fontSize={14}>{`A busca encontrou`}</Label>
                <LabelCount>{totalContribuintes}</LabelCount>
                <Label fontSize={14}>{`contribuintes.`}</Label>
              </ContainerCount>
            ) : null}
            {totalContribuintes !== undefined && totalContribuintes > 0 && (
              <Row>
                <Col>
                  <ContainerInput>
                    <Label htmlFor="dataVencimento">
                      Data Vencimento Início
                    </Label>
                    <InputComponent
                      type="date"
                      name="dataVencimentoInicio"
                      id="dataVencimentoInicio"
                      value={parcela.dataVencimentoInicio}
                      onChange={(e) => {
                        handleDateChange(
                          e.target.value,
                          "dataVencimentoInicio"
                        );
                      }}
                      placeholder="00/00/0000"
                      color="#333"
                      width={Number("100%")}
                      border="1px solid #ccc"
                      // disabled={isRequired}
                    />
                  </ContainerInput>
                </Col>
                <Col>
                  <ContainerInput>
                    <Label htmlFor="dataVencimento">Data Vencimento Fim</Label>
                    <InputComponent
                      type="date"
                      name="dataVencimentoFim"
                      id="dataVencimentoFim"
                      value={parcela.dataVencimentoFim}
                      onChange={(e) => {
                        handleDateChange(e.target.value, "dataVencimentoFim");
                      }}
                      placeholder="00/00/0000"
                      color="#333"
                      width={Number("100%")}
                      border="1px solid #ccc"
                      // disabled={isRequired}
                    />
                  </ContainerInput>
                </Col>
              </Row>
            )}
          </ModalBody>

          <ModalFooter>
            {/* <button type="submit" className="btn-submit">Cadastrar Parcelas</button> */}
            <Button
              schemaButton="full-primary"
              type="button"
              disabled={
                isRequest ||
                totalContribuintes === undefined ||
                totalContribuintes === 0
              }
              action={handleSubmit}
            >
              Cadastrar Parcelas
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalContainer>
      {modalDetalhesAberto &&
        responseCreateFinancialRecordAllContribuintesDto && (
          <ModalDetalhes
            id={1}
            data={responseCreateFinancialRecordAllContribuintesDto}
            show={modalDetalhesAberto}
            onClose={() => handleCloseModal()}
          />
        )}
    </MainContainer>
  );
};

export default CadastroParcelasVariosContribuintes;
